import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import ProposalScenarioInsights
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentDefault/LeftSide/TabsPicker/Tabs/TabContentPicker/TabContent/Content/TabLayouts/Insights/Default/ProposalScenarioInsights';
import WarningMessage from '../../Components/AlertMessage';
import { metaOverrideSet } from './ProposalScenarioInsights/InsightSection/metaOverrideSet';

const styles = theme => ({
  root: {},
  group: {},
  alert: {
    margin: theme.spacing(3, 3, 0, 3),
  },
});

const Insights = ({
  className, classes, collection,
}) => {
  const { refreshPageContentCollection } = usePageContentContext();
  const [resource] = collection;
  const hasWarning = resource.attr('warningMessage') && Boolean(resource.attr('warningMessage') !== '');

  return (
    <Box className={classNames(classes.root, className)}>
      <WarningMessage
        className={classes.alert}
        visible={hasWarning}
        message={resource.attr('warningMessage')}
        test={'facet-plan-cfp-warning'}
      />
      <MetaCollectionFormInline
        collection={resource.attr('resources')}
        FormProps={{
          layout: ProposalScenarioInsights,
          LayoutProps: {
            hideErrorList: true,
            onSubmit: () => {
              // refresh must happen after the autosave
              refreshPageContentCollection();
            },
          },
          readonly: true, // needed to hide action buttons
        }}
        padding={'none'}
        metaOverrideSet={metaOverrideSet}
      />
    </Box>
  );
};

Insights.defaultProps = {
  className: '',
};

Insights.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  collection: PropTypes.object.isRequired,
};

export default withStyles(styles)(Insights);
